export const getHomepage = async wixCodeApi => {
  const { pages } = await wixCodeApi.site.getSiteStructure();
  return pages.find(page => page.isHomePage);
};
